import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

import { CorporateService } from "../corporate.service";

@Component({
  selector: "app-corporate-dashboard",
  templateUrl: "./corporate-dashboard.component.html",
  styleUrls: ["./corporate-dashboard.component.css"],
})
export class CorporateDashboardComponent implements OnInit {
  token: any;
  dashboardArray: any = [];
  dashboard: boolean = false;
  expiringTrip: boolean = false;
  partially: boolean = false;
  loading: boolean = false;

  constructor(
    private router: Router,
    private services: CorporateService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.dashboardGet();
  }
  GoToDashboard() {
    this.router.navigateByUrl("/corporate/dashboard");
  }
  GoToBookATrips() {
    this.router.navigateByUrl("/corporate");
  }
  GoToTrips() {
    this.router.navigateByUrl("/corporate/trips");
  }
  GoTOWorkOrders() {
    this.router.navigateByUrl("/corporate/work-order-list");
  }
  GoToLedger() {
    this.router.navigateByUrl("/corporate/ledger");
  }
  GoTOHelp() {
    this.router.navigateByUrl("/?target=support");
  }
  dashboardGet() {
    this.loading = true;
    this.services.dashboard(this.token).subscribe(
      (response: any) => {
        this.loading = false;
        this.dashboardArray = response.body.data;
        if (this.dashboardArray.liveTrips == 0) {
          this.dashboard = true;
        }
        if (this.dashboardArray.partiallyPaid == 0) {
          this.partially = true;
        }
        if (this.dashboardArray.tripsExpiry == 0) {
          this.expiringTrip = true;
        }
      },
      (error) => {
        this.loading = false;
        this.dashboardArray = [];
        if (error.status == 404) {
          return;
        }
        if (error.status === 401) {
          this.router.navigateByUrl("/");
          localStorage.removeItem("corporate_token");
          localStorage.removeItem("corporateProfilePic");
          localStorage.removeItem("corporateUserName");
          localStorage.removeItem("corporate_user_type");
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.removeItem("corporate_token");
          localStorage.removeItem("corporateProfilePic");
          localStorage.removeItem("corporateUserName");
          localStorage.removeItem("corporate_user_type");
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.removeItem("corporate_token");
          localStorage.removeItem("corporateProfilePic");
          localStorage.removeItem("corporateUserName");
          localStorage.removeItem("corporate_user_type");
        }
        if (error.status == 404) {
          this.dashboard = true;
          this.partially = true;
          this.expiringTrip = true;
        } else {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      }
    );
  }
}
